module.exports = __webpack_public_path__ + "media/photo/AdobeStock_168038223@2x-92fa8e8b.jpg";